module.exports = __webpack_public_path__ + "img/IMG_3511.ea10b86e.jpeg";